import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function PageLoadingFallback() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center py-32">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="w-7 h-7 text-blue-500 animate-spin" />
        <p className="text-slate-600 dark:text-slate-500 text-sm">{t('common.loading_module')}</p>
      </div>
    </div>
  );
}
